import React, { Fragment, useState } from 'react';
import { Grid } from '@material-ui/core';

import { GQLMerchantDeliveryType, GQLParty } from '@jewelutions/core-crm-server-api-client-domain';

import { ErrorComponent, LoadingSpinner, DetailsList, SectionCard } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

interface IProps {
  party: GQLParty;
}

const DeliverySettings: React.FC<IProps> = ({ party }: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);

  const {
    data,
    loading,
    error,
    refetch
  } = GQLOperationBuilder.merchant.getPlatformSaleCatalogWithPlatformMerchantContracts({
    merchantPartyId: party.id,
    includeOnlyActiveContracts: true
  });

  if (loading) return <LoadingSpinner />;

  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={error?.stack}
        callback={refetch}
        message={error.message}
      />
    );

  const platformMerchantContract = GQLOperationBuilder.merchant.platformSaleCatalogWithPlatformMerchantContractsArrayFromResponse(
    data
  )[0].platformMerchantContract!;

  return (
    <Fragment>
      <Grid item style={{ marginTop: '8px' }}>
        <SectionCard title="Sales Channel delivery">
          <DetailsList
            list={
              platformMerchantContract.delivery.deliveryType === GQLMerchantDeliveryType.Warehouse
                ? [
                    {
                      primary: 'Delivery type',
                      secondary: platformMerchantContract.delivery.deliveryType + ''
                    },
                    {
                      primary: 'Company name',
                      secondary: platformMerchantContract.delivery.warehouseDelivery?.companyName + ''
                    },
                    {
                      primary: 'Company address',
                      secondary:
                        platformMerchantContract.delivery.warehouseDelivery?.address.street +
                        ' ' +
                        platformMerchantContract.delivery.warehouseDelivery?.address.streetNumber +
                        ' ' +
                        platformMerchantContract.delivery.warehouseDelivery?.address.streetExtra
                    },
                    {
                      primary: 'City',
                      secondary: platformMerchantContract.delivery.warehouseDelivery?.address.city + ''
                    },
                    {
                      primary: 'Country',
                      secondary: platformMerchantContract.delivery.warehouseDelivery?.address.country + ''
                    }
                  ]
                : [
                    {
                      primary: 'Delivery type',
                      secondary: platformMerchantContract.delivery.deliveryType + ''
                    },
                    {
                      primary: 'Destination',
                      secondary: 'As indicated in each individual order.'
                    }
                  ]
            }
          />
        </SectionCard>
      </Grid>
    </Fragment>
  );
};

export default DeliverySettings;
